module.exports = __webpack_public_path__ + "static/media/icon-manager.d98eafea.svg";